export enum CheckoutFeature {
  Ipid = 'checkoutIpid',
  Landing = 'checkoutLanding',
  MarketingPreferences = 'checkoutMarketingPreferences',
  PersonalDetails = 'checkoutPersonalDetails',
  TermsAndConditions = 'checkoutTermsAndConditions',
}
